import { CustomIMSConfigResource } from '../resources';
import { UserGeneratedConfig } from 'app/shared/collections/UserGeneratedConfig';
import { ImsObjectIncrementalCollection } from 'app/shared/collections/ims_object_incremental_collection.service';
import { IIntervalService, IRootScopeService } from 'angular';
import { ViewStateService } from 'app/shared/view_state.service';
import { LayerTypeOptionsByTypeName } from 'app/overview/config/data/MapLayerOptionsHelper';
import { SiteStateService } from '../site_state.service';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';

/**
 * @ngdoc service
 * @name ims.shared.data.service:configCollectionService
 * @description
 * IMS custom config. It handles loading and refreshing data.
 * Note that it is entirely on-demand. Config must be loaded on request.
 */

export class ConfigCollection extends ImsObjectIncrementalCollection {
    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $rootScope: IRootScopeService,
        $interval: IIntervalService,
        viewStateService: ViewStateService,
        siteStateService: SiteStateService,
    ) {
        super(
            startUpRegistry,
            localStorageService,
            $rootScope,
            $interval,
            viewStateService,
            siteStateService,
            CustomIMSConfigResource,
            UserGeneratedConfig,
        );
    }

    /**
     * Get the imagery layer definitions from the API. Used for form rendering and validation
     * @returns {Promise<LayerTypeOptionsByTypeName>}
     */
    async getImageryLayerDefinitions(): Promise<LayerTypeOptionsByTypeName> {
        if (!this.resourceObjectBase.getImageryLayerDefinitions) {
            throw new Error(
                `Expecting function getImageryLayerDefinitions on resource but got nothing!`,
            );
        }
        const result = await this.resourceObjectBase.getImageryLayerDefinitions().$promise;
        // Strip out unwanted keys that angular resource kindly adds for us...
        return Object.keys(result).reduce((accum, key) => {
            if (!['$resolved', '$promise'].includes(key)) {
                accum[key] = result[key];
            }
            return accum;
        }, {});
    }
}
